export default __webpack_public_path__ + "static/DINPro-Bold-e5319b02e9a3c105ec742e2b958c8646.eot";